import { render, staticRenderFns } from "./VideoAddLayer.vue?vue&type=template&id=f1294cc2&scoped=true&"
import script from "./VideoAddLayer.vue?vue&type=script&lang=js&"
export * from "./VideoAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoAddLayer.vue?vue&type=style&index=0&id=f1294cc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1294cc2",
  null
  
)

export default component.exports